import { useEffect, useRef, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  Typography,
  Box,
  Button,
} from "@mui/material/";
import { makeStyles } from "@mui/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import ImageIcon from "@mui/icons-material/Image";
import { useLanguageContext } from "../../../Context/LanguageContext";
import InspectionImagePopOver from "../Question/InspectionImagePopOver";
import InspectionFeedBack from "../CheckList/InspectionFeedBack";
import SummaryAccordionDetails from "./SummaryAccordionDetails";
import ShowEquipmentStatus from "./ShowEquipmentStatus";
import CreateTicket from "../TicketCreation/CreateTicket";

const useStyles = makeStyles((theme) => ({
  accordionWrapper: {
    marginBottom: theme.spacing(2),
  },
  accordion: {
    border: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider} !important`,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
    marginBottom: theme.spacing(2),
  },
  fileInput: {
    display: "none",
  },
}));

function SummaryAccordion({
  summaryData,
  handleSaveInspection,
  isInspectionRequired,
  inspectionImage,
  handleSummaryAction,
  equipmentDetails,
  setIsEquipmentNio,
  handleAbort,
  isEquipmentNio,
  handleCreateTicketCheckboxChange,
  showCanCreateTicketCheckbox,
  isCreateTicketActive,
}) {
  const classes = useStyles();
  const { localization } = useLanguageContext();
  const { mandatory, nonMandatory, counts } = summaryData;
  const fileInputRef = useRef(null);
  const [tempInspection, setTempInspection] = useState([]);
  const [showInspectionImage, setShowInspectionImage] = useState({
    isShow: false,
    imageList: null,
  });
  const [inputFeedBack, setInputFeedBack] = useState("");
  const [feedBackRequiredError, setFeedBackRequiredError] = useState(false);
  const [inputTitle, setInputTitle] = useState("");
  const [titleRequiredError, setTitleRequiredError] = useState(false);
  const [description, setDescription] = useState("");
  const [descriptionRequiredError, setDescriptionRequiredError] =
    useState(false);
  const [category, setCategory] = useState(" ");
  const [categoryRequiredError, setCategoryRequiredError] = useState(false);
  const [priority, setPriority] = useState("Low");
  const [priorityRequiredError, setPriorityRequiredError] = useState(false);
  const [isEquipmentNioOrIo, setIsEquipmentNioOrIo] = useState("");
  const [isImageRequiredError, setIsImageRequiredError] = useState(false);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChanges = (event) => {
    const files = Array.from(event.target.files).filter((file) =>
      file.type.startsWith("image/"),
    );

    let tempFileArray = [];
    if (files && files.length > 0) {
      files.forEach((file) => {
        let reader = new FileReader();
        reader.onload = () => {
          tempFileArray.push({
            Filename: file.name,
            Filecontent: reader.result,
            Filetyp: file.type,
            FileContentBytes: null,
          });
          setTempInspection(tempFileArray);
        };
        reader.onerror = () => {};
        reader.readAsDataURL(file);
      });
    }
  };

  useEffect(() => {
    if (tempInspection.length > 0 && !(tempInspection instanceof File)) {
      let _tempImage = tempInspection;
      if (inspectionImage && _tempImage) {
        _tempImage = [...inspectionImage, ..._tempImage];
      }
      setIsImageRequiredError(_tempImage.length === 0);
      handleSummaryAction(
        "inspectionImage",
        _tempImage.length === 0 ? null : _tempImage,
      );
    }
  }, [tempInspection]);
  const forFeedBack = (_value) => {
    if ("bothioandnio" === _value.toLowerCase()) {
      return true;
    } else if ("onlynio" === _value.toLowerCase()) {
      if (isEquipmentNio) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  function handleBlurFeedBack(_value) {
    if (forFeedBack(isInspectionRequired.isFeedBack)) {
      if (feedBackRequiredError) {
        setFeedBackRequiredError(_value === "" ? true : false);
      } else if (_value === "") {
        setFeedBackRequiredError(true);
      }
    }
  }

  function handleBlurTitle(_value) {
    setTitleRequiredError(_value === "" ? true : false);
  }

  function handleBlurDescription(_value) {
    setDescriptionRequiredError(_value === "" ? true : false);
  }

  function handleBlurCategory(_value) {
    setCategoryRequiredError(false);
  }

  function handleBlurPriority(_value) {
    setPriorityRequiredError(_value === "" ? true : false);
  }

  function handleImageDel(_index) {
    const _inspectionImage = inspectionImage.filter(
      (item, index) => _index !== index,
    );
    setShowInspectionImage((prev) => ({
      ...prev,
      imageList: _inspectionImage,
    }));
    setIsImageRequiredError(_inspectionImage.length === 0);
    handleSummaryAction(
      "inspectionImage",
      _inspectionImage.length === 0 ? null : _inspectionImage,
    );
  }

  const handleSave = (e) => {
    if (isCreateTicketActive && inputTitle === "") {
      setTitleRequiredError(true);
    } else if (isCreateTicketActive && description === "") {
      setDescriptionRequiredError(true);
    } else if (isCreateTicketActive && priority === "") {
      setPriorityRequiredError(true);
    } else if (
      forFeedBack(isInspectionRequired.isFeedBack) &&
      inputFeedBack === ""
    ) {
      setFeedBackRequiredError(true);
    } else if (forFeedBack(isInspectionRequired.isImage) && !inspectionImage) {
      setIsImageRequiredError(true);
    } else {
      handleSaveInspection(
        e,
        inputTitle,
        description,
        category,
        priority,
        inputFeedBack,
      );
    }
  };

  return (
    summaryData && (
      <>
        <div>
          {counts.totalMandatoryQuestions !== 0 && (
            <Box className={classes.accordionWrapper}>
              <Accordion
                className={classes.accordion}
                disabled={
                  Object.values(mandatory).length === 0 ||
                  !isInspectionRequired.isCheckListCritical
                }
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <div className="d-block">
                    <Typography variant="h6">{`${
                      counts.totalMandatoryQuestions -
                      counts.totalEmptyMandatoryQuestions
                    } / ${counts.totalMandatoryQuestions} ${
                      localization.mandatoryChecksCompleted
                    }`}</Typography>
                    <Typography variant="h6">
                      {counts.criticalIssueMandtory === 0
                        ? localization.noIssueHasBeenReported
                        : ` ${counts.criticalIssueMandtory} ${localization.issueReported}`}
                    </Typography>
                  </div>
                </AccordionSummary>
                {isInspectionRequired.isCheckListCritical && (
                  <SummaryAccordionDetails
                    keyForList={mandatory}
                    handleCreateTicketCheckboxChange={
                      handleCreateTicketCheckboxChange
                    }
                    showCanCreateTicketCheckbox={showCanCreateTicketCheckbox}
                  />
                )}
              </Accordion>
            </Box>
          )}
          {counts.totalNonMandatoryQuestions !== 0 && (
            <Box className={classes.accordionWrapper}>
              <Accordion
                disabled={
                  Object.values(nonMandatory).length === 0 ||
                  !isInspectionRequired.isCheckListCritical
                }
                className={classes.accordion}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <div className="d-block">
                    <Typography variant="h6">{`${
                      counts.totalNonMandatoryQuestions -
                      counts.totalEmptyNonMandatoryQuestions
                    } / ${counts.totalNonMandatoryQuestions} ${
                      localization.optionalChecksCompleted
                    }`}</Typography>
                    <Typography variant="h6">
                      {counts.criticalIssueNonMandtory === 0
                        ? localization.noIssueHasBeenReported
                        : ` ${counts.criticalIssueNonMandtory} ${localization.issueReported}`}
                    </Typography>
                  </div>
                </AccordionSummary>
                {isInspectionRequired.isCheckListCritical && (
                  <SummaryAccordionDetails keyForList={nonMandatory} />
                )}
              </Accordion>
            </Box>
          )}
        </div>
        <ShowEquipmentStatus
          mandatory={mandatory}
          nonMandatory={nonMandatory}
          isInspectionRequired={isInspectionRequired}
          counts={counts}
          setIsEquipmentNioOrIo={setIsEquipmentNioOrIo}
          setIsEquipmentNio={setIsEquipmentNio}
        />
        {isCreateTicketActive && (
          <CreateTicket
            equipmentDetails={equipmentDetails}
            setInputTitleValue={setInputTitle}
            titleRequiredError={titleRequiredError}
            handleBlurTitle={handleBlurTitle}
            setDescriptionValue={setDescription}
            descriptionRequiredError={descriptionRequiredError}
            handleBlurDescription={handleBlurDescription}
            setCategoryValue={setCategory}
            categoryRequiredError={categoryRequiredError}
            handleBlurCategory={handleBlurCategory}
            isCreateTicketActive={isCreateTicketActive}
            setPriorityValue={setPriority}
            priorityRequiredError={priorityRequiredError}
            handleBlurPriority={handleBlurPriority}
          />
        )}
        <InspectionFeedBack
          equipmentDetails={equipmentDetails}
          setInputFeedBackValue={setInputFeedBack}
          isInspectionRequired={isInspectionRequired}
          feedBackRequiredError={feedBackRequiredError}
          handleBlurFeedBack={handleBlurFeedBack}
        />
        {forFeedBack(isInspectionRequired.isImage) && (
          <div className="row justify-content-center">
            <div className="col d-flex justify-content-center">
              <input
                type="file"
                ref={fileInputRef}
                className={classes.fileInput}
                onChange={handleFileChanges}
                multiple
                accept="image/"
                capture="environment"
              />
              <Box display="flex" flexDirection="column">
                <CameraAltOutlinedIcon
                  onClick={handleButtonClick}
                  className="ml-2 summaryIcon"
                />
                <Box mt={1} onClick={handleButtonClick}>
                  {localization.takePicture}
                </Box>
                {isImageRequiredError && (
                  <div className="row mt-2 errorCls">
                    {localization.validationImageRequired}
                  </div>
                )}
              </Box>
              {inspectionImage && (
                <Box display="flex" flexDirection="column" className="ml-4">
                  <ImageIcon
                    className="ml-2 summaryIcon"
                    onClick={() =>
                      setShowInspectionImage({
                        isShow: true,
                        imageList: inspectionImage,
                      })
                    }
                  />
                  <Box
                    mt={1}
                    onClick={() =>
                      setShowInspectionImage({
                        isShow: true,
                        imageList: inspectionImage,
                      })
                    }
                  >
                    {localization.viewImage}
                  </Box>
                </Box>
              )}
            </div>
          </div>
        )}
        {!(
          isInspectionRequired.isCheckListCritical &&
          counts.noCriticalIssue === 0 &&
          isEquipmentNioOrIo === ""
        ) && (
          <div className="row ml-2 mr-1 mt-4 justify-content-center">
            <Button
              className="mr-1 buttonRounded summaryAbortButton"
              onClick={handleAbort}
            >
              {localization.abort}
            </Button>
            <Button
              className="buttonRounded summarySaveButton"
              onClick={handleSave}
            >
              {localization.save}
            </Button>
          </div>
        )}
        {showInspectionImage.isShow && (
          <InspectionImagePopOver
            handleImagePopover={() =>
              setShowInspectionImage({ isShow: false, imageList: null })
            }
            imageList={showInspectionImage.imageList}
            handleImageDel={handleImageDel}
          />
        )}
      </>
    )
  );
}

export default SummaryAccordion;
